<ng-container *transloco="let t">
  @if (!noData()) {
    <div class="sov-wrapper">
      <div class="left-wrapper">
        <div class="left-wrapper-dd">
          <div class="mb-3 inline-flex w-full items-center justify-between">
            <div class="inline-flex items-center">
              <div class="box-title">{{ t("common.keywords") }}</div>
              <button iButton size="xs" class="ml-2" [disabled]="!!isReadonly()" (click)="addNewKeyword()">
                <IIcon name="plus" />
                {{ t("share-of-voice.add_keyword") }}
              </button>
            </div>
            <div class="keyword-count-badge">
              {{ allSearchTerms().length }}
            </div>
          </div>

          <ISelectMenu
            [value]="focusedSearchTerm()"
            (valueChange)="focusSearchTerm($event)"
            [(searchQuery)]="searchQuery"
            fitTriggerWidth
          >
            <ISelectTrigger class="flex w-full">
              <ISelectValue />
            </ISelectTrigger>
            <ISelectContent>
              @for (term of filteredSearchTerms(); track term) {
                <ISelectOption [value]="term">
                  {{ term }}
                </ISelectOption>
              }
            </ISelectContent>
          </ISelectMenu>
        </div>
        <div class="left-wrapper-table">
          @if (!isSearchTermError()) {
            <app-sov-main-table
              [sovByBrand]="sovByBrandDate()"
              [brandColors]="brandColors()"
              [loading]="!!loading()"
              (emitHoveredBrand)="hoveredBrands = $event"
              (emitBrandSelection)="setBrandSelection($event)"
            ></app-sov-main-table>
          }
        </div>
      </div>
      <div class="charts-wrapper flex flex-col">
        <div class="flex w-full justify-between">
          <div class="box-title">{{ t("share-of-voice.share_of_voice_report") }}</div>
          <app-export-button
            (export)="exportToCsv()"
            tooltipValue="{{ t('common.export_as_csv') }}"
          ></app-export-button>
        </div>
        <div class="main-box flex flex-col">
          <div class="trend-chart-ctn">
            @if (!isSearchTermError()) {
              <app-sov-main-chart
                [loading]="!!loading()"
                [sovData]="sovByBrandDate()"
                [brandSelection]="brandSelection"
                [hoveredBrand]="hoveredBrands"
                [brandColors]="brandColors()"
                (emitSnapshotDate)="snapshotDate.set($event)"
              ></app-sov-main-chart>
            }
          </div>
          <div class="snapshot-chart-ctn mx-auto w-[90%]">
            @if (!isSearchTermError()) {
              <app-sov-pie-chart
                [loading]="!!loading()"
                [sovData]="sovByBrandDate()"
                [brandSelection]="brandSelection"
                [hoveredBrand]="hoveredBrands"
                [brandColors]="brandColors()"
                [snapshotDate]="snapshotDate()"
              ></app-sov-pie-chart>
            } @else {
              <IAlert [title]="'Error with search term ' + focusedSearchTerm()" type="error" />
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="flex h-full w-full items-center justify-center">
      <IEmptyState
        [title]="t('share-of-voice.no_data_found_for_this_marketplace')"
        [description]="t('share-of-voice.no_data_found_for_this_marketplace_description')"
        [ctaLabel]="t('share-of-voice.add_keyword')"
        ctaIcon="add"
        [ctaDisabled]="!!isReadonly()"
        (ctaClick)="addNewKeyword()"
      />
    </div>
  }
</ng-container>
